import { atom } from "jotai";
import { BoardCache } from "shared/datamodel/schemas";
import {
  MY_BOARDS_SECTION_ID,
  RECENT_BOARDS_SECTION_ID,
  SHARED_WITH_ME_SECTION_ID,
  BoardsSections,
} from "shared/datamodel/schemas/board-section";

export const boardCacheAtom = atom<BoardCache>({});

const initialState: BoardsSections = {
  [MY_BOARDS_SECTION_ID]: { boards: [], id: MY_BOARDS_SECTION_ID },
  [RECENT_BOARDS_SECTION_ID]: { boards: [], id: RECENT_BOARDS_SECTION_ID },
  [SHARED_WITH_ME_SECTION_ID]: { boards: [], id: SHARED_WITH_ME_SECTION_ID },
};

export const boardsSectionsAtom = atom<BoardsSections>(initialState);
